/* * 本页面为仓库新增和仓库修改界面 * 通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
      <div class="title-explain">
        <i class="e6-icon-abnormal_fill"></i>
        <span
          >仓库联系人将自动注册粤冷链，账号为电话，密码默认为电话后六位</span
        >
      </div>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              label="冷库名称"
              prop="forms.storageName"
              :rules="[
                {
                  required: true,
                  message: '请输入冷库名称',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.storageName"
                placeholder="冷库名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.comparyId"
              label="所属企业"
              :rules="[
                {
                  required: true,
                  message: '请选择所属企业',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="slotForms.forms.comparyId"
                collapse-tags
                filterable
                placeholder="所属企业"
              >
                <el-option
                  v-for="item in allCustomer"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item-->
            <!--prop="forms.provinceId"-->
            <!--label="所属省"-->
            <!--:rules="[-->
            <!--{-->
            <!--required: true,-->
            <!--message: '请选择所属省',-->
            <!--trigger: 'change'-->
            <!--}-->
            <!--]"-->
            <!--&gt;-->
            <!--<el-select-->
            <!--v-model="slotForms.forms.provinceId"-->
            <!--placeholder="所属省"-->
            <!--@change="provinceChange"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in provinceList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->

            <!--<el-form-item-->
            <!--prop="forms.cityName"-->
            <!--label="所属市"-->
            <!--:rules="[-->
            <!--{-->
            <!--required: true,-->
            <!--message: '请选择所属市',-->
            <!--trigger: 'change'-->
            <!--}-->
            <!--]"-->
            <!--&gt;-->
            <!--<el-select-->
            <!--v-model="slotForms.forms.cityName"-->
            <!--placeholder="所属市"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in cityList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.name"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <div class="group_form">
              <el-form-item
                label="冷库地址"
                prop="forms.regisArea"
                class="address"
              >
                <e6-city
                  ref="e6City"
                  :format="$GLOBAL_CONFIG.e6City.format"
                  :placeholder="
                    slotForms.forms.regisArea == ''
                      ? $GLOBAL_CONFIG.e6City.placeholder
                      : slotForms.forms.regisArea
                  "
                  :label="slotForms.forms.regisArea"
                  class="e6-city"
                  @selected="citySelect"
                  :fixed-bin="$GLOBAL_CONFIG.e6City.bin"
                ></e6-city>
              </el-form-item>
              <el-form-item prop="forms.storagePosition">
                <el-button
                  @click="selectStoragePosition()"
                  :class="slotForms.forms.storagePosition ? '' : 'show_tips'"
                >
                  <span :title="storagePosition" class="register-txt">{{
                    slotForms.forms.storagePosition
                  }}</span>
                  <i class="e6-icon-map_line"></i>
                </el-button>
              </el-form-item>
            </div>
            <el-form-item
              prop="forms.coldStorageType"
              label="冷库类型"
              :rules="[
                { required: true, message: '请选择冷库类型', trigger: 'change' }
              ]"
            >
              <dict-select
                v-model="slotForms.forms.coldStorageType"
                placeholder="请选择冷库类型"
                :pkey="'cold_storage_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              label="容积"
              prop="forms.volume"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.volume"
                placeholder="系统将自动加和冷库包含库区容积"
                clearable
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.storageGood"
              label="储存物品"
              :rules="[
                {
                  required: true,
                  message: '请输入或选择储存物品',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                ref="dictSelect"
                v-model="slotForms.forms.storageGoodObject"
                size="mini"
                clearable
                filterable
                placeholder="请输入或选择"
                default-first-option
                value-key="dicId"
                @blur="selectBlur($event)"
              >
                <el-option
                  v-for="item in storageGoodList"
                  :key="item.dicId"
                  :label="item.dicName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item
              label="冷库建筑平面图"
              prop="forms.buildPlanPath"
              :rules="[{ validator: CheckRemarkLength, trigger: 'blur' }]"
            >
              <el-input
                v-model="slotForms.forms.buildPlanPath"
                placeholder="冷库建筑平面图"
                clearable
              ></el-input>
            </el-form-item> -->
            <!--<el-form-item-->
            <!--label="地理位置"-->
            <!--prop="forms.storagePosition"-->
            <!--:rules="[-->
            <!--{-->
            <!--required: true,-->
            <!--message: '请输入地理位置',-->
            <!--trigger: 'blur'-->
            <!--},-->
            <!--{ validator: CheckRemarkLength, trigger: 'blur' }-->
            <!--]"-->
            <!--&gt;-->
            <!--<el-input-->
            <!--v-model="slotForms.forms.storagePosition"-->
            <!--placeholder="地理位置"-->
            <!--clearable-->
            <!--&gt;</el-input>-->
            <!--</el-form-item>-->

            <div
              v-for="(item, idx) in formExtend.forms.contactMenInfoVOList"
              :key="idx"
            >
              <el-form-item
                label="联系人"
                :prop="'forms.contactMenInfoVOList.' + idx + '.contactMan'"
                :rules="[
                  {
                    validator: CheckComparyNameLength,
                    trigger: 'blur'
                  },

                  {
                    required: true,
                    message: '请输入联系人姓名',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="slotForms.forms.contactMenInfoVOList[idx].contactMan"
                  placeholder="联系人"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                label="电话"
                :prop="'forms.contactMenInfoVOList.' + idx + '.contactPhone'"
                :rules="contactPhoneCheck"
              >
                <el-input
                  v-model="
                    slotForms.forms.contactMenInfoVOList[idx].contactPhone
                  "
                  placeholder="电话"
                  clearable
                ></el-input>
                <el-button
                  type="text"
                  class="item-button"
                  @click="addContactPhone"
                  v-if="
                    idx === formExtend.forms.contactMenInfoVOList.length - 1
                  "
                  >添加联系人</el-button
                >
                <el-button
                  type="text"
                  class="item-button"
                  v-if="formExtend.forms.contactMenInfoVOList.length > 1"
                  @click="removeContactPhone(idx)"
                  >删除</el-button
                >
              </el-form-item>
              <!-- 
              <el-form-item v-if="idx === 0">
                <el-button type="text">新增联系人</el-button>
              </el-form-item>
              <el-form-item v-else>
                <el-button type="text">新增联系人</el-button>
                <el-button type="text">删除</el-button>
              </el-form-item> -->
            </div>

            <el-form-item label="冷库建成日期" prop="productionDate">
              <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="slotForms.forms.productionDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="已使用时长" prop="forms.applyTime">
              <el-input
                :disabled="true"
                v-model="slotForms.forms.applyTime"
                placeholder="已使用时长"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.storagePurposeList" label="冷库用途">
              <el-select
                v-model="slotForms.forms.storagePurposeList"
                collapse-tags
                filterable
                multiple
                value-key="dicId"
                placeholder="冷库用途"
              >
                <el-option
                  v-for="item in storagePurposeLists"
                  :key="item.dicId"
                  :label="item.dicName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="冷库库体(M)"
              prop="forms.storageLength"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                style="width:90px"
                v-model="slotForms.forms.storageLength"
                placeholder="长"
                clearable
              ></el-input>
              X
              <el-input
                style="width:90px"
                v-model="slotForms.forms.storageWide"
                placeholder="宽"
                clearable
              ></el-input>
              X
              <el-input
                style="width:90px"
                v-model="slotForms.forms.storageHigh"
                placeholder="高"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              v-show="false"
              label="厚度"
              prop="forms.thick"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.thick"
                placeholder="厚度"
                clearable
                v-show="false"
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.preventFireLevel" label="防火等级">
              <dict-select
                v-model="slotForms.forms.preventFireLevel"
                placeholder="请选择防火等级"
                :pkey="'prevent_fire_level'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.keepwarmType" label="保温形式">
              <dict-select
                v-model="slotForms.forms.keepwarmType"
                placeholder="请选择保温形式"
                :pkey="'keepwarm_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.machineRoom" label="机房">
              <dict-select
                v-model="slotForms.forms.machineRoom"
                placeholder="请选择机房"
                :pkey="'machine_room'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.machineGroupType" label="机组形式">
              <dict-select
                v-model="slotForms.forms.machineGroupType"
                placeholder="请选择机组形式"
                :pkey="'machine_group_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              label="机组台数"
              prop="forms.parallelNum"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.parallelNum"
                placeholder="机组台数"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="使用压缩机厂家"
              prop="forms.compressorCompany"
              :rules="[{ validator: CheckComparyNameLength, trigger: 'blur' }]"
            >
              <el-input
                v-model="slotForms.forms.compressorCompany"
                placeholder="使用压缩机厂家"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.condensationType" label="冷凝方式">
              <dict-select
                v-model="slotForms.forms.condensationType"
                placeholder="请选择冷凝方式"
                :pkey="'condensation_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.feedliquid" label="供液方式">
              <dict-select
                v-model="slotForms.forms.feedliquid"
                placeholder="请选择供液方式"
                :pkey="'feedliquid'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.evaporator" label="蒸发器">
              <dict-select
                v-model="slotForms.forms.evaporator"
                placeholder="请选择蒸发器"
                :pkey="'evaporator'"
              ></dict-select>
            </el-form-item>
            <el-form-item label="是否有风道" prop="forms.hasDuct">
              <el-radio v-model="slotForms.forms.hasDuct" :label="0"
                >否</el-radio
              >
              <el-radio v-model="slotForms.forms.hasDuct" :label="1"
                >是</el-radio
              >
            </el-form-item>
            <el-form-item prop="forms.pipeMode" label="排管方式">
              <dict-select
                v-model="slotForms.forms.pipeMode"
                placeholder="请选择排管方式"
                :pkey="'pipe_mode'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.storageDoor" label="冷库门">
              <dict-select
                v-model="slotForms.forms.storageDoor"
                placeholder="请选择冷库门"
                :pkey="'storage_door'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              label="每天平均开门次数"
              prop="forms.openDoorNum"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.openDoorNum"
                placeholder="每天平均开门次数"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.shipmentList" label="出货方式">
              <el-select
                v-model="slotForms.forms.shipmentList"
                collapse-tags
                filterable
                multiple
                value-key="dicId"
                placeholder="出货方式"
              >
                <el-option
                  v-for="item in shipmentLists"
                  :key="item.dicId"
                  :label="item.dicName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="forms.railwayPltform" label="月台">
              <dict-select
                v-model="slotForms.forms.railwayPltform"
                placeholder="请选择月台"
                :pkey="'railway_pltform'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              label="月台尺寸(M)"
              prop="forms.railwayLength"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                style="width:90px"
                v-model="slotForms.forms.railwayLength"
                placeholder="长"
                clearable
              ></el-input>
              X
              <el-input
                style="width:90px"
                v-model="slotForms.forms.railwayWide"
                placeholder="宽"
                clearable
              ></el-input>
              X
              <el-input
                style="width:90px"
                v-model="slotForms.forms.railwayHigh"
                placeholder="高"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="出货口"
              prop="forms.shipmentPortNum"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.shipmentPortNum"
                placeholder="出货口"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="出货口尺寸(M)"
              prop="forms.portLength"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' }
              ]"
            >
              <el-input
                style="width:90px"
                v-model="slotForms.forms.portLength"
                placeholder="长"
                clearable
              ></el-input>
              X
              <el-input
                style="width:90px"
                v-model="slotForms.forms.portWide"
                placeholder="宽"
                clearable
              ></el-input>
              X
              <el-input
                style="width:90px"
                v-model="slotForms.forms.portHigh"
                placeholder="高"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="监控设备商" prop="forms.monitorDeviceMerchant">
              <el-input
                v-model="slotForms.forms.monitorDeviceMerchant"
                placeholder="监控设备商"
                clearable
              ></el-input> </el-form-item
            ><br />
            <!--上传图片 start-->
            <el-form-item label="冷链图片上传">
              <div class="upload-img">
                <template v-for="(v, index) in pictureSourceList">
                  <div :key="index" class="img-content">
                    <div class="imgCss">
                      <upload-img
                        height="100px"
                        width="120px"
                        type="update"
                        :cardTitle="v.cardTitle"
                        v-model="v.pictureUrl"
                        @callback="data => uploadCallback()"
                        @removeUrl="data => uploadRemoveCallback(data, index)"
                      ></upload-img>
                    </div>
                  </div>
                </template>
              </div>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
    <!-- 地图控件 -->
    <small-map
      ref="mapWin"
      title="地图标注"
      :optionMap="optionMap"
      :city="city"
      @showMapInfo="getMapInfo"
    ></small-map>
  </div>
</template>
``
<script>
import e6City from "e6city";
import smallMap from "@/components/smallMap/smallMap";
import { SaveStorageInfo, FindStorageInfoById } from "@/api/base/storage";
import resizeListener from "_private/mixins/resizeListener";
import uploadImg from "@/components/uploadImg";
import {
  CheckRemarkLength,
  CheckPriceOrDistance,
  CheckPhone,
  validatorIntNum,
  CheckNumberLength,
  CheckComparyNameLength
} from "@/utils/validation";
import { FetchGetArea } from "@/api/public";
import { FetchAllCustomer } from "@/api/systemSetting/interfaceUserManager";
const emptyPictureSourceList = [
  // 从业人员照片
  {
    title: "冷库照片",
    cardTitle: "上传冷库照片",
    pictureType: "storagePhoto",
    pictureUrl: ""
  }
];
export default {
  components: { e6City, smallMap, uploadImg },

  mixins: [resizeListener],
  data() {
    // // 选择地图详情
    // const addressRule = (rule, value, callback) => {
    //   if (!this.formExtend.forms.storagePosition.length) {
    //     callback("请点击地图选择详情地址");
    //   } else {
    //     callback();
    //   }
    // };
    //校验手机号唯一性
    var contactPhoneCheck = (rule, value, callback) => {
      if (value === "") {
        return callback();
      } else {
        let list = this.formExtend.forms.contactMenInfoVOList;
        let judge = 0;
        list.map(v => {
          if (v.contactPhone === value) {
            judge = judge + 1;
          }
        });
        if (judge > 1) {
          return callback(new Error("同一仓库多个联系人电话不可相同"));
        } else {
          return callback();
        }
      }
    };
    return {
      // 地图跳转传参
      optionMap: {
        lng: "",
        lat: "",
        city: "", //选择的城市名
        level: "", //省、市、区
        location: ""
      },
      city: "", //选择的市区
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/baseStorageList",
          isRedirect: true,
          meta: {
            title: "仓库基础信息"
          }
        }
      ],
      formExtend: {
        forms: {
          storageName: "",
          comparyId: "",
          provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          provinceId: "",
          cityName: $GLOBAL_CONFIG.e6City.cityName,
          storagePurposeList: [],
          buildPlanPath: "",
          storagePosition: "",
          contactMenInfoVOList: [
            {
              contactMan: "",
              contactPhone: ""
            }
          ],
          applyTime: "",
          storageGoodObject: "",
          storageGood: "", //储存物品Id
          storageGoodText: "", //储存物品名称
          volume: "",
          storageLength: "",
          storageWide: "",
          storageHigh: "",
          thick: "",
          preventFireLevel: "",
          keepwarmType: "",
          machineRoom: "",
          machineGroupType: "",
          parallelNum: "",
          compressorCompany: "",
          condensationType: "",
          feedliquid: "",
          evaporator: "",
          isVipMember: "",
          pipeMode: "",
          storageDoor: "",
          openDoorNum: "",
          shipmentList: [],
          railwayPltform: "",
          railwayLength: "",
          railwayWide: "",
          railwayHigh: "",
          shipmentPortNum: "",
          portLength: "",
          portWide: "",
          portHigh: "",
          regisArea: "",
          countyName: "",
          monitorDeviceMerchant: "",
          productionDate: "",
          coldStorageType: "" //冷库类型
        },
        extends: []
      },
      pictureSourceList: JSON.parse(JSON.stringify(emptyPictureSourceList)),
      editState: false,
      isDisable: true,
      provinceList: [],
      cityList: [],
      allCustomer: [],
      storagePurposeLists: [],
      shipmentLists: [],
      CheckRemarkLength: CheckRemarkLength,
      CheckPriceOrDistance: CheckPriceOrDistance,
      CheckPhone: CheckPhone,
      validatorIntNum: validatorIntNum,
      CheckNumberLength: CheckNumberLength,
      CheckComparyNameLength: CheckComparyNameLength,
      loadingState: false,
      storagePosition: "",
      storageGoodList: [], //储存物品下拉数据

      //联系人电话校验
      contactPhoneCheck: [
        { validator: CheckPhone, trigger: "blur" },
        {
          validator: contactPhoneCheck,
          trigger: "blur"
        },
        { required: true, message: "请输入联系人电话", trigger: "blur" }
      ],
      isWatch: true
    };
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle =
        this.pageType === "1" ? "仓库基础信息新增" : "仓库基础信息修改";
      return pageTitle;
    },
    id() {
      return this.$route.query.id;
    },
    provinceId() {
      return this.$route.query.provinceId;
    }
  },
  watch: {
    //当包含多个联系人时，不论哪一个联系人电话改变，都需要触发唯一性校验
    "formExtend.forms.contactMenInfoVOList": {
      handler() {
        this.formExtend.forms.contactMenInfoVOList.map((v, idx) => {
          this.$refs["formExtend"].validateField([
            `forms.contactMenInfoVOList.${idx}.contactPhone`
          ]);
        });
      },
      deep: true //true 深度监听
    },
    "formExtend.forms.storageGoodObject": {
      handler(val) {
        if (this.isWatch) {
          if (val === "") {
            this.formExtend.forms.storageGood = "";
            this.formExtend.forms.storageGoodText = "";
          } else if (val.dicId != undefined) {
            this.formExtend.forms.storageGood = val.dicId;
            this.formExtend.forms.storageGoodText = val.dicName;
          } else if (val.dicId === undefined) {
            this.formExtend.forms.storageGood = 0;
            this.formExtend.forms.storageGoodText = val;
          }
        } else {
          this.isWatch = true;
        }
      },
      deep: true //true 深度监听
    }
  },
  created() {
    this.initServiceObjectSelect();
    this.initOperateProductSelect();
    this.FetchGetArea(0, 1, 1);
    this.getStorageGoodList();
    this.initAllCustomer();
    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
    if (this.pageType !== "1") {
      this.isWatch = false;
      this.FindStorageInfoById({ storageId: this.id });
      this.editState = true;
    }
  },
  methods: {
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.cityName("澳门");
        this.optionMap.level = "city";
      } else if (res.province.name == "香港") {
        this.cityName("香港");
        this.optionMap.level = "city";
      } else if (res.province.name == "台湾省") {
        this.cityName("台湾省");
        this.optionMap.level = "city";
      } else {
        this.formExtend.forms.regisArea =
          res.province.name + res.city.name + res.district.name;
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
        this.city = res.city.name;
        this.optionMap.city = res.city.name;
        if (res.district.name === "") {
          if (res.city.name === "") {
            this.optionMap.level = "province";
          } else {
            this.optionMap.level = "city";
          }
        } else {
          this.optionMap.level = "district";
        }
      }
    },
    selectStoragePosition() {
      if (!this.formExtend.forms.regisArea.length) {
        this.$message.warning("请先选择省/市/区县");
        return;
      }

      this.optionMap.location = this.formExtend.forms.storagePosition;
      this.$refs.mapWin.showMap();
      // this.$refs.mapWin.loadQuery();
    },
    //初始化储存物品
    getStorageGoodList() {
      this.$axios
        .post(
          "/base/dictionary/getDictByDicTypeKey",
          this.$qs.stringify({ dicTypeKey: "store_item" })
        )
        .then(e => {
          if (e.data.code === 1) {
            this.storageGoodList = e.data.result;
          } else {
            this.errorMessage(e.data.message, e.data.code);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     *  初始化冷库用途字典列表
     */
    initServiceObjectSelect() {
      this.$axios
        .post(
          "/base/dictionary/getDictByDicTypeKey",
          this.$qs.stringify({
            dicTypeKey: "storage_purpose"
          })
        )
        .then(e => {
          if (e.data.code === 1) {
            this.storagePurposeLists = e.data.result;
          } else {
            this.errorMessage(e.data.message, e.data.code);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     *  初始化出货方式字典列表
     */
    initOperateProductSelect() {
      this.$axios
        .post(
          "/base/dictionary/getDictByDicTypeKey",
          this.$qs.stringify({
            dicTypeKey: "shipment"
          })
        )
        .then(e => {
          if (e.data.code === 1) {
            this.shipmentLists = e.data.result;
          } else {
            this.errorMessage(e.data.message, e.data.code);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     *  初始化企业下拉信息
     */
    initAllCustomer() {
      FetchAllCustomer()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allCustomer = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 根据父级获取地区下拉框
    FetchGetArea(parentId, type, num) {
      FetchGetArea(parentId, type)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            if (num == 1) {
              this.provinceList = response.result;
            } else if (num == 2) {
              this.cityList = response.result;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //省选择事件
    provinceChange() {
      this.cityList = [];
      this.formExtend.forms.cityName = "";
      this.provinceList.forEach(item => {
        if (this.formExtend.forms.provinceId == item.id) {
          this.formExtend.forms.provinceName = item.name;
          return;
        }
      });
      this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2);
    },
    // 修改仓库数据时，先获取仓库数据信息
    FindStorageInfoById(response) {
      FindStorageInfoById(response)
        .then(response => {
          this.formExtend.forms = Object.assign({}, response.result);
          if (this.provinceId) {
            this.formExtend.forms.provinceId = this.provinceId;
          } else {
            this.formExtend.forms.provinceId = "";
          }
          //当联系人数组返回为空时的处理
          if (
            Array.isArray(this.formExtend.forms.contactMenInfoVOList) &&
            this.formExtend.forms.contactMenInfoVOList.length <= 0
          ) {
            this.formExtend.forms.contactMenInfoVOList = [
              {
                contactMan: "",
                contactPhone: ""
              }
            ];
          }
          this.FetchGetArea(this.provinceId, 2, 2);
          this.formExtend.forms.regisArea =
            this.formExtend.forms.provinceName +
            this.formExtend.forms.cityName +
            this.formExtend.forms.countyName;
          this.optionMap.city = this.formExtend.forms.cityName;
          this.city = this.formExtend.forms.cityName;
          if (this.formExtend.forms.countyName === "") {
            if (this.formExtend.forms.cityName === "") {
              this.optionMap.level = "province";
            } else {
              this.optionMap.level = "city";
            }
          } else {
            this.optionMap.level = "district";
          }
          // 设置经纬度
          if (
            this.formExtend.forms.lon >= 0 &&
            this.formExtend.forms.lat >= 0
          ) {
            this.optionMap.lng = this.formExtend.forms.lon;
            this.optionMap.lat = this.formExtend.forms.lat;
          }

          // 回显图片
          // 处理图片数据
          this.formExtend.forms.buildPlanPath && this.handelPhoto();

          //回显储存物品

          this.$set(
            this.formExtend.forms,
            "storageGoodObject",
            response.result.storageGoodText
          );

          if (response.result.storageGood === undefined) {
            this.formExtend.forms.storageGood = 0;
            this.formExtend.forms.storageGoodText =
              response.result.storageGoodText;
          } else {
            this.formExtend.forms.storageGood = response.result.storageGood;
            this.formExtend.forms.storageGoodText =
              response.result.storageGoodStr;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 新增，修改仓库数据
    SaveStorageInfo(response) {
      SaveStorageInfo(response)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 新增仓库信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push({
              path: "/baseStorageList",
              query: { refreshportion: true }
            });
          }
          this.loadingState = false;
        }
      });
    },
    // 重组照片
    handelPhoto() {
      let url = this.formExtend.forms.buildPlanPath.split(",");
      if (url.length) {
        let tempArr = [];
        url.forEach(v => {
          let obj = {
            title: "冷库照片",
            cardTitle: `上传冷库照片`,
            pictureType: "storagePhoto",
            pictureUrl: v
          };
          tempArr.push(obj);
        });
        if (tempArr.length < 5) {
          let emptyArr = [
            {
              title: "冷库照片",
              cardTitle: `上传冷库照片`,
              pictureType: "storagePhoto",
              pictureUrl: ""
            }
          ];
          this.pictureSourceList = [...tempArr, ...emptyArr];
        } else {
          this.pictureSourceList = [...tempArr];
        }
      }
    },
    // 上传附件的回调
    uploadCallback() {
      this.addPic("冷库照片", "storagePhoto");
    },
    addPic(name, value) {
      this.pictureSourceList.length < 5 &&
        this.pictureSourceList.push({
          title: name,
          cardTitle: `上传${name}`,
          pictureType: value,
          pictureUrl: ""
        });
    },
    // 删除文件的回调
    uploadRemoveCallback(data, index) {
      this.pictureSourceList.splice(index, 1);
      if (
        this.pictureSourceList.length < 5 &&
        this.pictureSourceList[this.pictureSourceList.length - 1].pictureUrl !=
          ""
      ) {
        this.addPic("冷库照片", "storagePhoto");
      }
    },
    // 提交
    handleSubmitForm(e) {
      if (e) {
        this.loadingState = true;
        // 处理照片参数
        let picArr = [];
        this.pictureSourceList.forEach(v => {
          if (v.pictureUrl) {
            picArr.push(v.pictureUrl);
          }
        });
        this.formExtend.forms.buildPlanPath = picArr.join(",");

        this.SaveStorageInfo(Object.assign({}, this.formExtend.forms));
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/baseStorageList");
    },
    // 地图标注回调
    getMapInfo(data) {
      this.formExtend.forms.storagePosition = data.location;
      this.formExtend.forms.lon = data.lng;
      this.formExtend.forms.lat = data.lat;
      this.storagePosition = data.location;
    },
    cityName(name) {
      this.formExtend.forms.regisArea = name;
      this.city = name;
      this.optionMap.city = name;
    },

    //添加联系人
    addContactPhone() {
      this.formExtend.forms.contactMenInfoVOList.push({
        contactMan: "",
        contactPhone: ""
      });
    },
    // 删除联系人
    removeContactPhone(idx) {
      this.formExtend.forms.contactMenInfoVOList.splice(idx, 1);
    },
    //储存物品选择框回调
    selectBlur(e) {
      if (e.target.value.length > 30) {
        this.$message.info("储存物品的长度不得超过30");
      } else {
        this.formExtend.forms.storageGoodObject = e.target.value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-demo {
  width: 300px;
  margin: 10 150px 10px 200px;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
    .group_form {
      width: 50%;
      display: inline-block;
      vertical-align: top;
      .el-form-item {
        width: auto;
        .e6-city {
          width: 178px;
          /deep/ .city-input {
            width: 100% !important;
          }
        }
        &:last-child {
          width: calc(100% - 398px);
          max-width: 300px;
          /deep/.el-form-item__content {
            width: 100%;
            .el-button {
              width: 100%;
              &.show_tips::before {
                content: "在地图上标注";
                color: #898c91;
                position: absolute;
              }
              span {
                display: inline-block;
                width: calc(100% - 20px);
                overflow: hidden;
                text-overflow: ellipsis;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
}
/deep/.hide .el-upload--picture-card {
  display: none;
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea__inner {
    width: 500px;
  }
}
.upload-img {
  margin-bottom: 20px;
  .img-content {
    display: inline-block;
    margin-right: 20px;
    .uploadImg-title {
      text-align: center;
      margin-top: 10px;
      color: #999;
      .require {
        color: #f56c6c;
        margin-right: 2px;
      }
    }
  }
}
.item-button {
  margin-left: 10px;
}
.title-explain {
  position: absolute;
  top: 25px;
  left: 175px;
  color: #898c91;
}
</style>
